import { Button } from "antd";
import axios from '../../../../context/axiosConfig'
import { useAuth } from "../../../../context/AuthContext";

const GenerateWplywRaport = ({wplywid, wplywownid}) => {
    const { user } = useAuth();
    const generate = async () => {
        try {
            const response = await axios.post("/wplyw/generate/raport/wplyw", {
                wplywid: wplywid,
                user: user.user.mlg_users_id
            }, {
                responseType: 'blob' // Important to handle file as binary
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');

            // Create a link to the file
            link.href = window.URL.createObjectURL(blob);
            link.download = `Raport wpływu #${wplywownid}`;
            link.click();

        } catch (error) {
            console.error("Błąd pobierania pliku:", error);
        }
    };

    return <Button onClick={() => generate()}>Generuj raport wpływu</Button>;
};

export default GenerateWplywRaport;